/* Syba creator-LP quiet mode — no Klaviyo discount popup for creator-page visitors.
 *
 * WHY (2026-10-08)
 * Creator landing pages (/pages/lp/<handle>, Meta ad destinations) tell the
 * visitor "10% off with my code, automatically applied at checkout". The
 * site-wide Klaviyo signup popups (one per language, "OPTIMONK - xx - REBUILD")
 * then offered a second, different discount in exchange for an email. Two
 * competing offers on a paid-traffic page is confusing and can cost the sale.
 *
 * WHAT THIS DOES
 *   - A visit to any /pages/lp/ page sets a sessionStorage flag, so the whole
 *     session that started on a creator page stays quiet (PDP, collection,
 *     cart drawer), not just the landing page itself.
 *   - While quiet, any Klaviyo POPUP or FLYOUT form is hidden the moment it
 *     mounts (MutationObserver runs before paint, so no flash): its body-level
 *     root gets display:none, so it cannot intercept clicks, and Klaviyo's
 *     body scroll lock is released. Embedded forms (footer signup etc.) are
 *     untouched.
 *   - Works for every language and every future popup form: it keys on
 *     Klaviyo's form type, never on a list of form ids.
 *
 * WHY NOT KLAVIYO URL TARGETING
 * The Klaviyo API cannot edit form targeting, so excluding /pages/lp/ means
 * hand-editing 10 forms (and every future one), and it would still show the
 * popup on the next page of the same visit.
 *
 * Klaviyo's close button is also clicked, as a courtesy. Measured on live
 * 2026-10-08: the runtime ignores that synthetic click (no close recorded,
 * node stays mounted but hidden). That is fine, and it means a visitor who
 * comes back later in a normal session still gets the popup.
 */
(function () {
  'use strict';
  if (window.__sybaLpQuiet) return; // idempotent under double-include

  var FLAG = 'syba_creator_lp_session';
  var QUIET_LABELS = ['POPUP Form', 'FLYOUT Form'];

  function isCreatorPath(pathname) {
    // Also matches locale-prefixed paths such as /fr-fr/pages/lp/...
    return /\/pages\/lp\//.test(pathname || '');
  }

  function shouldQuiet(pathname, storage) {
    // window.__sybaCreatorPage: set by sections/header.liquid on Plantsgiving creator
    // giveaway pages (regular pages with the custom.giveaway_creator metafield).
    if (isCreatorPath(pathname) || !!window.__sybaCreatorPage) {
      try { storage && storage.setItem(FLAG, '1'); } catch (e) { /* private mode: still quiet on this page */ }
      return true;
    }
    try { return !!storage && storage.getItem(FLAG) === '1'; } catch (e) { return false; }
  }

  function isQuietDialog(el) {
    return !!el && el.getAttribute && el.getAttribute('role') === 'dialog' &&
      QUIET_LABELS.indexOf(el.getAttribute('aria-label')) !== -1;
  }

  // The form's mount root is the ancestor that sits directly under <body>;
  // hiding that removes the overlay and the dialog together.
  function rootOf(el, body) {
    var node = el;
    while (node && node.parentElement && node.parentElement !== body) node = node.parentElement;
    return node || el;
  }

  function quiet(dialog, body) {
    if (!isQuietDialog(dialog) || dialog.getAttribute('data-syba-lp-quiet') === '1') return false;
    dialog.setAttribute('data-syba-lp-quiet', '1');
    var root = rootOf(dialog, body);
    root.style.setProperty('display', 'none', 'important');
    var close = dialog.querySelector('.klaviyo-close-form');
    if (close && typeof close.click === 'function') close.click();
    if (body && body.classList) body.classList.remove('klaviyo-prevent-body-scrolling');
    return true;
  }

  // Exposed for tests and QA (harmless in production).
  window.__sybaLpQuiet = { isCreatorPath: isCreatorPath, shouldQuiet: shouldQuiet, quiet: quiet, rootOf: rootOf, quieted: 0 };

  var storage = null;
  try { storage = window.sessionStorage; } catch (e) { storage = null; }
  if (!shouldQuiet(window.location.pathname, storage)) return;
  if (typeof MutationObserver !== 'function' || !document.body) return;

  var selector = QUIET_LABELS.map(function (l) { return '[role="dialog"][aria-label="' + l + '"]'; }).join(',');
  function scan(scope) {
    var list = (scope.matches && scope.matches(selector)) ? [scope] : [];
    if (scope.querySelectorAll) list = list.concat([].slice.call(scope.querySelectorAll(selector)));
    for (var i = 0; i < list.length; i++) if (quiet(list[i], document.body)) window.__sybaLpQuiet.quieted++;
  }

  scan(document.body);
  new MutationObserver(function (records) {
    for (var r = 0; r < records.length; r++) {
      var added = records[r].addedNodes;
      for (var n = 0; n < added.length; n++) if (added[n].nodeType === 1) scan(added[n]);
      // Klaviyo can set the label after mounting the node.
      if (records[r].type === 'attributes') scan(records[r].target);
    }
  }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-label', 'role'] });
})();
